import { useContext } from "react";

import { useTranslation } from "react-i18next";

import TableContext from "context/table/tableContext";

import { BLUETOOTH_PASSWORD_SOURCE } from "../../../types/enums";
import Password from "./Password";
import Unknown from "./Unknown";

const BluetoothPassword = () => {
    const { detailsData } = useContext(TableContext);

    const { t } = useTranslation();

    const {
        bluetooth_password_source
    }: { bluetooth_password_source: BLUETOOTH_PASSWORD_SOURCE } = detailsData;

    return (
        <>
            <span>{t("General##bluetooth password")}</span>

            {bluetooth_password_source === BLUETOOTH_PASSWORD_SOURCE.Fota ? (
                <Password />
            ) : (
                <Unknown />
            )}
        </>
    );
};

export default BluetoothPassword;
